import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";


( function( $ ) {
    $(document).ready(function(){
        if($('.single-ai1ec_event').length){
            $("footer.timely.ai1ec-event-footer").after($('.ai1ec-actions'));
            $("footer.timely.ai1ec-event-footer").after($('.ai1ec-tags'));
            $("footer.timely.ai1ec-event-footer").after($('.ai1ec-categories'));
            var width = $(window).width();
            if (width <= 767) {
                $(".ai1ec-actions").after($('.ai1ec-event-avatar.timely'));
            } else {
                $(".ai1ec-event-details.ai1ec-clearfix").after($('.ai1ec-event-avatar.timely'));
            }
            setTimeout(function(){
                var eventImg = $(".ai1ec-event-avatar img");
                var imgWidth = eventImg.attr('width');
                var imgHeight = eventImg.attr('height');
                var hrefImg = eventImg.attr('src');
                var ret = hrefImg.replace('-'+imgWidth + 'x' + imgHeight, '');
                eventImg.attr('src', ret);
            },100);
        }
        $(".ai1ec-category-filter").click(function(){
            $(".ai1ec-category-filter.ai1ec-dropdown-menu").slideToggle();
        });

        $(".ai1ec-tag-filter").click(function(){
            $(".ai1ec-tag-filter.ai1ec-dropdown-menu").slideToggle();
        });

        if($(".institutskalender").length){
            $(".ai1ec-agenda-view .ai1ec-date>a").removeAttr("href");
            $(".institutskalender .ai1ec-subscribe-dropdown .ai1ec-hidden-xs").text("Zum Kalender hinzufügen");

            var width = $(window).width();
            if (width <= 767) {
                $(".timely.ai1ec-calendar-toolbar.ai1ec-clearfix").after($('.ai1ec-subscribe-dropdown'));
            } else {
                $(".ai1ec-agenda-view").after($('.ai1ec-subscribe-dropdown'));
            }
        }

        if($(".single.institutskalender").length){
            var getEmail = $('a.u-email').attr('href');
            var showEmail = getEmail.replace('mailto:', '');
            $("a.u-email").text(showEmail);

            var getWebsite = $('a.u-url').attr('href');
            $("a.u-url").text('Website der Veranstaltung');
        }
    });
}( jQuery ));